var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4172 16.2078L14.4508 12.2414C15.2703 11.0063 15.75 9.52734 15.75 7.9375C15.75 3.62969 12.2453 0.125 7.9375 0.125C3.62969 0.125 0.125 3.62969 0.125 7.9375C0.125 12.2453 3.62969 15.75 7.9375 15.75C9.52734 15.75 11.0063 15.2703 12.2414 14.4508L16.2078 18.4172C16.8172 19.0273 17.8078 19.0273 18.4172 18.4172C19.0273 17.807 19.0273 16.818 18.4172 16.2078ZM2.46875 7.9375C2.46875 4.92188 4.92188 2.46875 7.9375 2.46875C10.9531 2.46875 13.4062 4.92188 13.4062 7.9375C13.4062 10.9531 10.9531 13.4062 7.9375 13.4062C4.92188 13.4062 2.46875 10.9531 2.46875 7.9375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.dbbed6c77867466158fa9fd8a198fe00.svg";
export { ForwardRef as ReactComponent };